import React from "react";

export default function PgLoader() {
    return (
        <div className="pgLoader">
            <img src="https://webadmin.puppet-gram.com/assets/dist/img/AdminLTELogo.png" />
        </div>
    );
}